const { createAction } = require('../helpers')
const {
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_ERROR,
  GET_LOGGED_IN_USER_RESET,

  POST_USER,
  POST_USER_SUCCESS,
  POST_USER_ERROR,
  POST_USER_RESET,

  EMAIL_OTP,
  EMAIL_OTP_SUCCESS,
  EMAIL_OTP_ERROR,
  EMAIL_OTP_RESET,

  IMPORT_USER,
  IMPORT_USER_SUCCESS,
  IMPORT_USER_ERROR,
  IMPORT_USER_RESET,

  BULK_UPDATE_USER,
  BULK_UPDATE_USER_SUCCESS,
  BULK_UPDATE_USER_ERROR,
  BULK_UPDATE_USER_RESET,

  GET_ALL_USERS,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_ERROR,
  GET_ALL_USERS_RESET,

  GET_SINGLE_USER,
  GET_SINGLE_USER_SUCCESS,
  GET_SINGLE_USER_ERROR,
  GET_SINGLE_USER_RESET,

  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_USER_RESET,

  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_RESET,

  GET_ADMIN_DOCTORS_LIST,
  GET_ADMIN_DOCTORS_LIST_SUCCESS,
  GET_ADMIN_DOCTORS_LIST_ERROR,
  GET_ADMIN_DOCTORS_LIST_RESET,

  GET_ADMIN_DOCTOR,
  GET_ADMIN_DOCTOR_SUCCESS,
  GET_ADMIN_DOCTOR_ERROR,
  GET_ADMIN_DOCTOR_RESET,

  CREATE_ADMIN_DOCTOR,
  CREATE_ADMIN_DOCTOR_SUCCESS,
  CREATE_ADMIN_DOCTOR_ERROR,
  CREATE_ADMIN_DOCTOR_RESET,

  UPDATE_ADMIN_DOCTOR,
  UPDATE_ADMIN_DOCTOR_SUCCESS,
  UPDATE_ADMIN_DOCTOR_ERROR,
  UPDATE_ADMIN_DOCTOR_RESET,

  UPDATE_ADMIN_DOCTOR_STATUS,
  UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS,
  UPDATE_ADMIN_DOCTOR_STATUS_ERROR,
  UPDATE_ADMIN_DOCTOR_STATUS_RESET,

  POST_ADMIN_DOCTOR_DIGITAL_SIG,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET,

  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_ERROR,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_RESET,

  POST_ADMIN_DOCTOR_AUTH_PIN,
  POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS,
  POST_ADMIN_DOCTOR_AUTH_PIN_ERROR,
  POST_ADMIN_DOCTOR_AUTH_PIN_RESET,

  POST_ADMIN_DOCTOR_SPECS,
  POST_ADMIN_DOCTOR_SPECS_SUCCESS,
  POST_ADMIN_DOCTOR_SPECS_ERROR,
  POST_ADMIN_DOCTOR_SPECS_RESET,

  DELETE_ADMIN_DOCTOR,
  DELETE_ADMIN_DOCTOR_SUCCESS,
  DELETE_ADMIN_DOCTOR_ERROR,
  DELETE_ADMIN_DOCTOR_RESET,

  GET_ALL_ADMIN_PANEL_USERS,
  GET_ALL_ADMIN_PANEL_USERS_SUCCESS,
  GET_ALL_ADMIN_PANEL_USERS_ERROR,
  GET_ALL_ADMIN_PANEL_USERS_RESET,
  GET_SINGLE_ADMIN_PANEL_USER,
  GET_SINGLE_ADMIN_PANEL_USER_SUCCESS,
  GET_SINGLE_ADMIN_PANEL_USER_ERROR,
  GET_SINGLE_ADMIN_PANEL_USER_RESET,
  CREATE_ADMIN_PANEL_USER,
  CREATE_ADMIN_PANEL_USER_SUCCESS,
  CREATE_ADMIN_PANEL_USER_ERROR,
  CREATE_ADMIN_PANEL_USER_RESET,
  UPDATE_ADMIN_PANEL_USER,
  UPDATE_ADMIN_PANEL_USER_SUCCESS,
  UPDATE_ADMIN_PANEL_USER_ERROR,
  UPDATE_ADMIN_PANEL_USER_RESET,

  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  GET_PROFILE_RESET,

  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_RESET,

  POST_DOC_DIGITAL_INFO,
  POST_DOC_DIGITAL_INFO_SUCCESS,
  POST_DOC_DIGITAL_INFO_ERROR,
  POST_DOC_DIGITAL_INFO_RESET,

  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_ERROR,
  USER_LOGIN_RESET,

  USER_REGISTRATION,
  USER_REGISTRATION_SUCCESS,
  USER_REGISTRATION_ERROR,
  USER_REGISTRATION_RESET,

  APPLE_LOGIN,
  APPLE_LOGIN_SUCCESS,
  APPLE_LOGIN_ERROR,
  APPLE_LOGIN_RESET,

  LOGIN_GOOGLE,
  LOGIN_GOOGLE_SUCCESS,
  LOGIN_GOOGLE_ERROR,
  LOGIN_GOOGLE_RESET,

  UPDATE_EMAIL,
  UPDATE_EMAIL_SUCCESS,
  UPDATE_EMAIL_ERROR,
  UPDATE_EMAIL_RESET,

  NUMBER_VALIDATION,
  NUMBER_VALIDATION_SUCCESS,
  NUMBER_VALIDATION_ERROR,
  NUMBER_VALIDATION_RESET,

  UPDATE_NUMBER,
  UPDATE_NUMBER_SUCCESS,
  UPDATE_NUMBER_ERROR,
  UPDATE_NUMBER_RESET,

  USER_LOGOUT,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_ERROR,

  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_RESET,

  PASSWORD_CHANGE,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_RESET,

  MARKETPLACE_PASSWORD_CHANGE,
  MARKETPLACE_PASSWORD_CHANGE_SUCCESS,
  MARKETPLACE_PASSWORD_CHANGE_ERROR,
  MARKETPLACE_PASSWORD_CHANGE_RESET,

  GET_DOCTOR_DETAILS,
  GET_DOCTOR_DETAILS_SUCCESS,
  GET_DOCTOR_DETAILS_ERROR,
  GET_DOCTOR_DETAILS_RESET,

  GET_DOCTOR_ID,
  GET_DOCTOR_ID_SUCCESS,
  GET_DOCTOR_ID_ERROR,
  GET_DOCTOR_ID_RESET,

  POST_DOCTOR_PIN,
  POST_DOCTOR_PIN_SUCCESS,
  POST_DOCTOR_PIN_ERROR,
  POST_DOCTOR_PIN_RESET,
} = require('./constants')

//email otp //
const emailOtp = ({ email, recaptchaToken }) =>
  createAction(EMAIL_OTP, {
    email,
    recaptchaToken,
  });

const emailOtpSuccess = (sessionId) =>
  createAction(EMAIL_OTP_SUCCESS, { sessionId });

const emailOtpError = (error, message) =>
  createAction(EMAIL_OTP_ERROR, { error, message });

const emailOtpReset = () => createAction(EMAIL_OTP_RESET);
//

const getLoggedInUser = () => createAction(GET_LOGGED_IN_USER)

const getLoggedInUserSuccess = user => createAction(GET_LOGGED_IN_USER_SUCCESS, { user })

const getLoggedInUserError = error => createAction(GET_LOGGED_IN_USER_ERROR, { error })

const getLoggedInUserReset = () => createAction(GET_LOGGED_IN_USER_RESET)

const postUser = userData => createAction(POST_USER, { userData })
const postUserSuccess = data => createAction(POST_USER_SUCCESS, { data })
const postUserError = error => createAction(POST_USER_ERROR, { error })
const postUserReset = () => createAction(POST_USER_RESET)

const importUser = userData => createAction(IMPORT_USER, { userData })
const importUserSuccess = data => createAction(IMPORT_USER_SUCCESS, { data })
const importUserError = error => createAction(IMPORT_USER_ERROR, { error })
const importUserReset = () => createAction(IMPORT_USER_RESET)

const bulkUpdateUser = userData => createAction(BULK_UPDATE_USER, { userData })
const bulkUpdateUserSuccess = data => createAction(BULK_UPDATE_USER_SUCCESS, { data })
const bulkUpdateUserError = error => createAction(BULK_UPDATE_USER_ERROR, { error })
const bulkUpdateUserReset = () => createAction(BULK_UPDATE_USER_RESET)

const getAllUsersList = ({
  take, skip, email, phoneNumber,
}) => createAction(GET_ALL_USERS, {
  take, skip, email, phoneNumber,
})
const getAllUsersListSuccess = data => createAction(GET_ALL_USERS_SUCCESS, { data })
const getAllUsersListError = error => createAction(GET_ALL_USERS_ERROR, { error })
const getAllUsersListReset = () => createAction(GET_ALL_USERS_RESET)

const getSingleUser = ({ id }) => createAction(GET_SINGLE_USER, { id })
const getSingleUserSuccess = data => createAction(GET_SINGLE_USER_SUCCESS, { data })
const getSingleUserError = error => createAction(GET_SINGLE_USER_ERROR, { error })
const getSingleUserReset = () => createAction(GET_SINGLE_USER_RESET)

const updateUser = ({ id, userData }) => createAction(UPDATE_USER, { id, userData })
const updateUserSuccess = data => createAction(UPDATE_USER_SUCCESS, { data })
const updateUserError = error => createAction(UPDATE_USER_ERROR, { error })
const updateUserReset = () => createAction(UPDATE_USER_RESET)

const deleteUser = ({ id }) => createAction(DELETE_USER, { id })
const deleteUserSuccess = data => createAction(DELETE_USER_SUCCESS, { data })
const deleteUserError = error => createAction(DELETE_USER_ERROR, { error })
const deleteUserReset = () => createAction(DELETE_USER_RESET)

// For Admin Users
const getAdminDoctorsList = ({
  take,
  skip,
  email,
  phoneNumber,
  search,
  find,
  role,
}) => createAction(GET_ADMIN_DOCTORS_LIST, {
  take,
  skip,
  email,
  phoneNumber,
  search,
  find,
  role,
})
const getAdminDoctorsListSuccess = data => createAction(GET_ADMIN_DOCTORS_LIST_SUCCESS, { data })
const getAdminDoctorsListError = error => createAction(GET_ADMIN_DOCTORS_LIST_ERROR, { error })
const getAdminDoctorsListReset = () => createAction(GET_ADMIN_DOCTORS_LIST_RESET)

// For Admin Users
const getAdminDoctor = id => createAction(GET_ADMIN_DOCTOR, { id })
const getAdminDoctorSuccess = data => createAction(GET_ADMIN_DOCTOR_SUCCESS, { data })
const getAdminDoctorError = error => createAction(GET_ADMIN_DOCTOR_ERROR, { error })
const getAdminDoctorReset = () => createAction(GET_ADMIN_DOCTOR_RESET)

// For Admin Users
const createAdminDoctor = docData => createAction(CREATE_ADMIN_DOCTOR, { docData })
const createAdminDoctorSuccess = data => createAction(CREATE_ADMIN_DOCTOR_SUCCESS, { data })
const createAdminDoctorError = error => createAction(CREATE_ADMIN_DOCTOR_ERROR, { error })
const createAdminDoctorReset = () => createAction(CREATE_ADMIN_DOCTOR_RESET)

// For Admin Users
const updateAdminDoctor = ({ id, docData }) => createAction(UPDATE_ADMIN_DOCTOR, { id, docData })
const updateAdminDoctorSuccess = data => createAction(UPDATE_ADMIN_DOCTOR_SUCCESS, { data })
const updateAdminDoctorError = error => createAction(UPDATE_ADMIN_DOCTOR_ERROR, { error })
const updateAdminDoctorReset = () => createAction(UPDATE_ADMIN_DOCTOR_RESET)

// For Admin Users;
const updateAdminDoctorStatus = ({ id, statusData }) => createAction(UPDATE_ADMIN_DOCTOR_STATUS, { id, statusData })
const updateAdminDoctorStatusSuccess = data => createAction(UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS, { data })
const updateAdminDoctorStatusError = error => createAction(UPDATE_ADMIN_DOCTOR_STATUS_ERROR, { error })
const updateAdminDoctorStatusReset = () => createAction(UPDATE_ADMIN_DOCTOR_STATUS_RESET)

// For Admin Users
const postAdminDoctorDigitalSig = ({ id, docData }) => createAction(POST_ADMIN_DOCTOR_DIGITAL_SIG, { id, docData })
const postAdminDoctorDigitalSigSuccess = data => createAction(POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS, { data })
const postAdminDoctorDigitalSigError = error => createAction(POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR, { error })
const postAdminDoctorDigitalSigReset = () => createAction(POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET)

// For Admin Users
const revokeAdminDoctorDigitalSig = ({ id }) => createAction(REVOKE_ADMIN_DOCTOR_DIGITAL_SIG, { id })
const revokeAdminDoctorDigitalSigSuccess = data => createAction(REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS, { data })
const revokeAdminDoctorDigitalSigError = error => createAction(REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_ERROR, { error })
const revokeAdminDoctorDigitalSigReset = () => createAction(REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_RESET)

// For Admin Users
const postAdminDoctorAuthPin = ({ id, authPinData }) => createAction(POST_ADMIN_DOCTOR_AUTH_PIN, { id, authPinData })
const postAdminDoctorAuthPinSuccess = data => createAction(POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS, { data })
const postAdminDoctorAuthPinError = error => createAction(POST_ADMIN_DOCTOR_AUTH_PIN_ERROR, { error })
const postAdminDoctorAuthPinReset = () => createAction(POST_ADMIN_DOCTOR_AUTH_PIN_RESET)

// For Admin Users
const postAdminDoctorSpecs = ({ id, specData }) => createAction(POST_ADMIN_DOCTOR_SPECS, { id, specData })
const postAdminDoctorSpecsSuccess = data => createAction(POST_ADMIN_DOCTOR_SPECS_SUCCESS, { data })
const postAdminDoctorSpecsError = error => createAction(POST_ADMIN_DOCTOR_SPECS_ERROR, { error })
const postAdminDoctorSpecsReset = () => createAction(POST_ADMIN_DOCTOR_SPECS_RESET)

// For Admin Users
const deleteAdminDoctor = ({ id }) => createAction(DELETE_ADMIN_DOCTOR, { id })
const deleteAdminDoctorSuccess = data => createAction(DELETE_ADMIN_DOCTOR_SUCCESS, { data })
const deleteAdminDoctorError = error => createAction(DELETE_ADMIN_DOCTOR_ERROR, { error })
const deleteAdminDoctorReset = () => createAction(DELETE_ADMIN_DOCTOR_RESET)

// For Admin Panel User/Personnel
const getAllAdminPanelUsers = ({
  role, take, skip, search, email, phoneNumber,
}) => createAction(GET_ALL_ADMIN_PANEL_USERS, {
  role, take, skip, search, email, phoneNumber,
})
const getAllAdminPanelUsersSuccess = data => createAction(GET_ALL_ADMIN_PANEL_USERS_SUCCESS, { data })
const getAllAdminPanelUsersError = error => createAction(GET_ALL_ADMIN_PANEL_USERS_ERROR, { error })
const getAllAdminPanelUsersReset = () => createAction(GET_ALL_ADMIN_PANEL_USERS_RESET)

// For Admin Panel User/Personnel
const getAdminPanelUser = id => createAction(GET_SINGLE_ADMIN_PANEL_USER, { id })
const getAdminPanelUserSuccess = data => createAction(GET_SINGLE_ADMIN_PANEL_USER_SUCCESS, { data })
const getAdminPanelUserError = error => createAction(GET_SINGLE_ADMIN_PANEL_USER_ERROR, { error })
const getAdminPanelUserReset = () => createAction(GET_SINGLE_ADMIN_PANEL_USER_RESET)

// For Admin Panel User/Personnel
const createAdminPanelUser = adminData => createAction(CREATE_ADMIN_PANEL_USER, { adminData })
const createAdminPanelUserSuccess = data => createAction(CREATE_ADMIN_PANEL_USER_SUCCESS, { data })
const createAdminPanelUserError = error => createAction(CREATE_ADMIN_PANEL_USER_ERROR, { error })
const createAdminPanelUserReset = () => createAction(CREATE_ADMIN_PANEL_USER_RESET)

// For Admin Panel User/Personnel
const updateAdminPanelUser = ({ id, adminData }) => createAction(UPDATE_ADMIN_PANEL_USER, { id, adminData })
const updateAdminPanelUserSuccess = data => createAction(UPDATE_ADMIN_PANEL_USER_SUCCESS, { data })
const updateAdminPanelUserError = error => createAction(UPDATE_ADMIN_PANEL_USER_ERROR, { error })
const updateAdminPanelUserReset = () => createAction(UPDATE_ADMIN_PANEL_USER_RESET)

const getProfile = () => createAction(GET_PROFILE)

const getProfileSuccess = user => createAction(GET_PROFILE_SUCCESS, { user })

const getProfileError = (error, message) => createAction(GET_PROFILE_ERROR, { error, message })

const getProfileReset = () => createAction(GET_PROFILE_RESET)

const updateProfile = user => createAction(UPDATE_PROFILE, { user })

const updateProfileSuccess = user => createAction(UPDATE_PROFILE_SUCCESS, { user })

const updateProfileError = error => createAction(UPDATE_PROFILE_ERROR, { error })

const updateProfileReset = () => createAction(UPDATE_PROFILE_RESET)

const postDocDigitalInfo = info => createAction(POST_DOC_DIGITAL_INFO, { info })

const postDocDigitalInfoSuccess = info => createAction(POST_DOC_DIGITAL_INFO_SUCCESS, { info })

const postDocDigitalInfoError = error => createAction(POST_DOC_DIGITAL_INFO_ERROR, { error })

const postDocDigitalInfoReset = () => createAction(POST_DOC_DIGITAL_INFO_RESET)

const userLogin = ({ email, password, recaptchaToken }) => createAction(USER_LOGIN, { email, password, recaptchaToken })

const userLoginSuccess = user => createAction(USER_LOGIN_SUCCESS, { user })

const userLoginError = (error, message) => createAction(USER_LOGIN_ERROR, { error, message })

const userLoginReset = () => createAction(USER_LOGIN_RESET)

const userRegistration = ({
  email,
  name,
  password,
  age,
  phoneNumber,
  height,
  dob,
  weight,
  gender,
  verificationStatus,
  emailVerificationStatus,
  countryCode,
  planId,
  partnerId,
  referrer,
  code,
  sessionId,
  recaptchaToken,
}) => createAction(USER_REGISTRATION, {
  email,
  name,
  password,
  age,
  phoneNumber,
  height,
  dob,
  weight,
  gender,
  verificationStatus,
  emailVerificationStatus,
  countryCode,
  planId,
  partnerId,
  referrer,
  code,
  sessionId,
  recaptchaToken,
})


const userRegistrationSuccess = user => createAction(USER_REGISTRATION_SUCCESS, { user })

const userRegistrationError = (error, message) => createAction(USER_REGISTRATION_ERROR, { error, message })

const userRegistrationReset = () => createAction(USER_REGISTRATION_RESET)

const appleLogin = ({ identityToken, user, referrer }) => createAction(APPLE_LOGIN, { identityToken, user, referrer })

const appleLoginSuccess = user => createAction(APPLE_LOGIN_SUCCESS, { user })

const appleLoginError = (error, message) => createAction(APPLE_LOGIN_ERROR, { error, message })

const appleLoginReset = () => createAction(APPLE_LOGIN_RESET)

const loginGoogle = ({ googleAccessToken, referrer }) => createAction(LOGIN_GOOGLE, { googleAccessToken, referrer })

const loginGoogleSuccess = user => createAction(LOGIN_GOOGLE_SUCCESS, { user })

const loginGoogleError = (error, message) => createAction(LOGIN_GOOGLE_ERROR, { error, message })

const loginGoogleReset = () => createAction(LOGIN_GOOGLE_RESET)

const validatePhoneNumber = ({
  type,
  countryCode,
  phoneNumber,
  recaptchaToken,
}) => createAction(NUMBER_VALIDATION, {
  type,
  countryCode,
  phoneNumber,
  recaptchaToken,
})

const validatePhoneNumberSuccess = sessionId => createAction(NUMBER_VALIDATION_SUCCESS, { sessionId })

const validatePhoneNumberError = (error, message) => createAction(NUMBER_VALIDATION_ERROR, { error, message })

const validatePhoneNumberReset = () => createAction(NUMBER_VALIDATION_RESET)

const userLogout = () => createAction(USER_LOGOUT)

const userLogoutSuccess = () => createAction(USER_LOGOUT_SUCCESS)

const userLogoutError = error => createAction(USER_LOGOUT_ERROR, { error })

const updateEmail = ({
  code, sessionId, email, countryCode, phoneNumber,
}) => createAction(UPDATE_EMAIL, {
  code,
  sessionId,
  email,
  countryCode,
  phoneNumber,
})

const updateEmailSuccess = data => createAction(UPDATE_EMAIL_SUCCESS, { data })

const updateEmailError = (error, message) => createAction(UPDATE_EMAIL_ERROR, { error, message })

const updateEmailReset = () => createAction(UPDATE_EMAIL_RESET)
const updateNumber = ({
  code, sessionId, email, countryCode, phoneNumber,
}) => createAction(UPDATE_NUMBER, {
  code,
  sessionId,
  email,
  countryCode,
  phoneNumber,
})

const updateNumberSuccess = data => createAction(UPDATE_NUMBER_SUCCESS, { data })

const updateNumberError = (error, message) => createAction(UPDATE_NUMBER_ERROR, { error, message })

const updateNumberReset = () => createAction(UPDATE_NUMBER_RESET)

// forgot password

const forgotPassword = ({
  password,
  phoneNumber,
  email,
  recaptchaToken,
  sessionId,
  code,
}) => createAction(FORGOT_PASSWORD, {
  password,
  phoneNumber,
  sessionId,
  code,
  email,
  recaptchaToken,
})

const forgotPasswordSuccess = sessionId => createAction(FORGOT_PASSWORD_SUCCESS, { sessionId })

const forgotPasswordError = (error, message) => createAction(FORGOT_PASSWORD_ERROR, { error, message })

const forgotPasswordReset = () => createAction(FORGOT_PASSWORD_RESET)

const changePassword = ({
  code, sessionId, password, recaptchaToken,
}) => createAction(PASSWORD_CHANGE, {
  code,
  sessionId,
  password,
  recaptchaToken,
})

const changePasswordSuccess = data => createAction(PASSWORD_CHANGE_SUCCESS, { data })

const changePasswordError = (error, message) => createAction(PASSWORD_CHANGE_ERROR, { error, message })

const changePasswordReset = () => createAction(PASSWORD_CHANGE_RESET)

const marketPlacePasswordChange = ({
  oldPassword,
  newPassword,
  retypePassword,
  recaptchaToken,
}) => createAction(MARKETPLACE_PASSWORD_CHANGE, {
  oldPassword,
  newPassword,
  retypePassword,
  recaptchaToken,
})
const marketPlacePasswordChangeSuccess = data => createAction(MARKETPLACE_PASSWORD_CHANGE_SUCCESS, { data })
const marketPlacePasswordChangeError = error => createAction(MARKETPLACE_PASSWORD_CHANGE_ERROR, { error })
const marketPlacePasswordChangeReset = () => createAction(MARKETPLACE_PASSWORD_CHANGE_RESET)

const getDoctorDetails = id => createAction(GET_DOCTOR_DETAILS, { id })
const getDoctorDetailsSuccess = data => createAction(GET_DOCTOR_DETAILS_SUCCESS, { data })
const getDoctorDetailsError = error => createAction(GET_DOCTOR_DETAILS_ERROR, { error })
const getDoctorDetailsReset = () => createAction(GET_DOCTOR_DETAILS_RESET)

const getDoctorId = id => createAction(GET_DOCTOR_ID, { id })
const getDoctorIdSuccess = data => createAction(GET_DOCTOR_ID_SUCCESS, { data })
const getDoctorIdError = error => createAction(GET_DOCTOR_ID_ERROR, { error })
const getDoctorIdReset = () => createAction(GET_DOCTOR_ID_RESET)

const postDoctorPin = pinData => createAction(POST_DOCTOR_PIN, { pinData })
const postDoctorPinSuccess = data => createAction(POST_DOCTOR_PIN_SUCCESS, { data })
const postDoctorPinError = error => createAction(POST_DOCTOR_PIN_ERROR, { error })
const postDoctorPinReset = () => createAction(POST_DOCTOR_PIN_RESET)

module.exports = {
  getLoggedInUser,
  getLoggedInUserSuccess,
  getLoggedInUserError,
  getLoggedInUserReset,

  postUser,
  postUserSuccess,
  postUserError,
  postUserReset,

  importUser,
  importUserSuccess,
  importUserError,
  importUserReset,

  bulkUpdateUser,
  bulkUpdateUserSuccess,
  bulkUpdateUserError,
  bulkUpdateUserReset,

  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordError,
  forgotPasswordReset,

  getAllUsersList,
  getAllUsersListSuccess,
  getAllUsersListError,
  getAllUsersListReset,

  getSingleUser,
  getSingleUserSuccess,
  getSingleUserError,
  getSingleUserReset,

  updateUser,
  updateUserSuccess,
  updateUserError,
  updateUserReset,

  deleteUser,
  deleteUserSuccess,
  deleteUserError,
  deleteUserReset,

  getAdminDoctorsList,
  getAdminDoctorsListSuccess,
  getAdminDoctorsListError,
  getAdminDoctorsListReset,

  getAdminDoctor,
  getAdminDoctorSuccess,
  getAdminDoctorError,
  getAdminDoctorReset,

  createAdminDoctor,
  createAdminDoctorSuccess,
  createAdminDoctorError,
  createAdminDoctorReset,

  updateAdminDoctor,
  updateAdminDoctorSuccess,
  updateAdminDoctorError,
  updateAdminDoctorReset,

  updateAdminDoctorStatus,
  updateAdminDoctorStatusSuccess,
  updateAdminDoctorStatusError,
  updateAdminDoctorStatusReset,

  postAdminDoctorDigitalSig,
  postAdminDoctorDigitalSigSuccess,
  postAdminDoctorDigitalSigError,
  postAdminDoctorDigitalSigReset,

  revokeAdminDoctorDigitalSig,
  revokeAdminDoctorDigitalSigSuccess,
  revokeAdminDoctorDigitalSigError,
  revokeAdminDoctorDigitalSigReset,

  postAdminDoctorAuthPin,
  postAdminDoctorAuthPinSuccess,
  postAdminDoctorAuthPinError,
  postAdminDoctorAuthPinReset,

  postAdminDoctorSpecs,
  postAdminDoctorSpecsSuccess,
  postAdminDoctorSpecsError,
  postAdminDoctorSpecsReset,

  deleteAdminDoctor,
  deleteAdminDoctorSuccess,
  deleteAdminDoctorError,
  deleteAdminDoctorReset,

  getAllAdminPanelUsers,
  getAllAdminPanelUsersSuccess,
  getAllAdminPanelUsersError,
  getAllAdminPanelUsersReset,
  getAdminPanelUser,
  getAdminPanelUserSuccess,
  getAdminPanelUserError,
  getAdminPanelUserReset,
  createAdminPanelUser,
  createAdminPanelUserSuccess,
  createAdminPanelUserError,
  createAdminPanelUserReset,
  updateAdminPanelUser,
  updateAdminPanelUserSuccess,
  updateAdminPanelUserError,
  updateAdminPanelUserReset,

  getProfile,
  getProfileSuccess,
  getProfileReset,
  getProfileError,

  updateProfile,
  updateProfileSuccess,
  updateProfileError,
  updateProfileReset,

  postDocDigitalInfo,
  postDocDigitalInfoSuccess,
  postDocDigitalInfoError,
  postDocDigitalInfoReset,

  userLogin,
  userLoginSuccess,
  userLoginError,
  userLoginReset,

  userRegistration,
  userRegistrationSuccess,
  userRegistrationError,
  userRegistrationReset,

  appleLogin,
  appleLoginSuccess,
  appleLoginError,
  appleLoginReset,

  loginGoogle,
  loginGoogleSuccess,
  loginGoogleError,
  loginGoogleReset,

  validatePhoneNumber,
  validatePhoneNumberSuccess,
  validatePhoneNumberError,
  validatePhoneNumberReset,

  updateEmail,
  updateEmailSuccess,
  updateEmailError,
  updateEmailReset,

  updateNumber,
  updateNumberSuccess,
  updateNumberError,
  updateNumberReset,

  userLogout,
  userLogoutSuccess,
  userLogoutError,

  changePassword,
  changePasswordSuccess,
  changePasswordError,
  changePasswordReset,

  marketPlacePasswordChange,
  marketPlacePasswordChangeSuccess,
  marketPlacePasswordChangeError,
  marketPlacePasswordChangeReset,

  getDoctorDetails,
  getDoctorDetailsSuccess,
  getDoctorDetailsError,
  getDoctorDetailsReset,

  getDoctorId,
  getDoctorIdSuccess,
  getDoctorIdError,
  getDoctorIdReset,

  postDoctorPin,
  postDoctorPinSuccess,
  postDoctorPinError,
  postDoctorPinReset,

  emailOtp,
  emailOtpError,
  emailOtpReset,
  emailOtpSuccess
}